import styled from "styled-components";
import { Modal } from 'react-bootstrap';

export const ContainerAdressChoice = styled.div`
  width : 100%;
  padding : 20px;
  display : flex;
  flex-direction: column; 
  text-align : center;
`

export const CustomModal = styled(Modal)`

`